
import {
  doQueryByOrgId,
  // getDefaultBillInfo,
  // getSysTenantDef,
  // getAccountInfo,
} from 'api/operate';

let _this = null;

export default {
  sendThis: (scope) => {
    _this = scope;
  },
  form: [
    {
      label: '跟单人员',
      value: 'localUserName',
      type: 'el-autocomplete',
      valueKey: 'linkman',
      placeholder: '请输入跟单人员姓名',
      hide: true,
      querySearchAsync: (queryString, cb) => {
        // cb 返回的是检索出来匹配的数组
        let resInfo = [];
        if (queryString && queryString.length) {
          // 如果修改了但是没选中新的，就清空相关的字段
          if (_this.otherFormData.localUserInfo.linkman !== queryString) {
            _this.$refs.baseForm.setVal('localPhone', '');
            _this.$refs.baseForm.setVal('localUser', '');
          }
          doQueryByOrgId({ linkman: queryString }).then((res) => {
            if (res && res.items) {
              resInfo = res.items;
            }
            cb(resInfo);
          });
        }
        cb(resInfo);
      },
      onSelect: (item) => {
        _this.otherFormData.localUserInfo = item;
        _this.setFollowUpLocal(_this.otherFormData.localUserInfo);
      },
    },
    {
      label: '跟单手机',
      value: 'localPhone',
      type: 'input',
      hide: true,
      readonly: true,
    },
    {
      label: '拦标价',
      value: 'guidePrice',
      type: 'input',
      hide: true,
    },
    {
      label: '承包价',
      value: 'totalFee',
      type: 'input',
      hide: true,
    },
    {
      label: '跟单人员id',
      value: 'localUser',
      type: 'input',
      readonly: true,
      hide: true,
    },
  ],
  rules: {
    localUserName: [
      { required: true, message: '请输入跟单人员', trigger: 'blur' },
    ],
    localPhone: [
      { required: true, message: '请输入跟单手机', trigger: 'blur' },
    ],
    guidePrice: [
      { required: true, message: '请输入拦标价', trigger: 'blur' },
    ],
    totalFee: [
      { required: true, message: '请输入承包价', trigger: 'blur' },
    ],
  },
};
